import { autoinject } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { SimpleOfferTabBase } from './simple-offer-tab-base';
import { NetOfferService } from 'services/net-offer-service';
import { ErrorService } from 'services/error-service';

@autoinject
export class SimpleOfferTabDome extends SimpleOfferTabBase {
  private nextTabIndex: number = null;
  private changeTabSubscription: Subscription;

  constructor(private eventAggregator: EventAggregator, netOfferService: NetOfferService, errorService: ErrorService) {
    super(netOfferService, errorService);
  }

  async activate() {
    // Get new tabIndex for tabs component via EA, store value so we can publish this if canDeactivate returns true
    this.changeTabSubscription = this.eventAggregator.subscribe('changeTab', (tabIndex: number) => {
      this.nextTabIndex = tabIndex;
    });
  }

  private detached() {
    if (this.changeTabSubscription) {
      this.changeTabSubscription.dispose();
    }
  }

  private deactivate() {
    if (this.changeTabSubscription) {
      this.changeTabSubscription.dispose();
    }
  }

  canDeactivate() {
    this.eventAggregator.publish('changeTab-success', this.nextTabIndex);
  }
}
